{
  "cancel": "Annuleren",
  "save": "Opslaan",
  "manage": "Beheren",
  "create": "Aanmaken",
  "delete": "Verwijderen",
  "new": "Nieuw",
  "event_nav_title": "Navigatie",
  "event_module_name_basic": "Basis",
  "event_module_name_sales": "Verkopen",
  "perc": "%",
  "currency": "€",
  "event_manage": "Evenement details",
  "event_manage_products": "Producten",
  "event_manage_status": "Status",
  "event_manage_minimum_age": "Naam evenement",
  "event_manage_minimum_age_info": "Laat dit veld leeg als er geen minimum leeftijd is",
  "event_manage_name": "Naam evenement",
  "event_product_title": "Beheer evenement producten",
  "event_product_saved": "Product details geupdate!",
  "event_product_add": "Nieuw product",
  "product_name": "Naam product",
  "product_modal_edit": "Wijzig product",
  "product_modal_create": "Maak product",
  "product_saved": "Product geupdate!",
  "product_group": "Groep",
  "product_status": "Status",
  "nav_dashboard": "Dashboard",
  "nav_companies": "Beheer bedrijven",
  "nav_events": "Mijn evenementen",
  "nav_company": "Mijn bedrijf",
  "nav_discountcodes": "Kortingscodes",
  "nav_orders": "Bestellingen",
  "nav_reports": "Rapporten",
  "nav_administration": "Administratie",
  "nav_extensions": "Uitbreidingen",
  "app_logout": "Uitloggen",
  "app_impersonating": "Je imiteert {name}. Klik op uitloggen om terug te gaan naar je eigen admin rol",
  "login_email": "E-mail",
  "login_password": "Wachtwoord",
  "login_button": "Login",
  "login_error": "Login mislukt, probeer opnieuw",
  "events_title": "Beheer evenementen",
  "event_create": "Maak nieuw evenement aan",
  "event_new_modal_title": "Evenement aanmaken",
  "event_name": "Naam evenement",
  "event_create_hint": "Nadat je het evenement hebt aangemaakt, kun je desgewenst meer opties instellen.",
  "event_nav_manage": "Details evenement",
  "event_nav_products": "Producten / Tickets",
  "event_nav_pos": "Verkooppunten",
  "event_nav_timeslots": "Tijdsloten",
  "event_manage_title": "Beheer jouw evenement: {name}",
  "event_minimum_age": "Minimum leeftijd",
  "event_status": "Status",
  "event_starts_at": "Event start op",
  "event_ends_at": "Event eindigt op",
  "event_description": "Omschrijving evenement",
  "company_manage_title": "Beheer bedrijf {name}",
  "company_users": "Bedrijf gebruikers",
  "company_details": "Bedrijf details",
  "company_subdomain": "Subdomain",
  "company_contact": "Contactpersoon",
  "company_phone": "Telefoonnummer",
  "company_address": "Adres",
  "company_zip": "Postcode",
  "company_city": "Stad",
  "company_kvk": "KVK nummer",
  "company_vat": "BTW nummer",
  "company_ticket_fee": "Fee per ticket",
  "company_paynl_service_id": "Pay.nl service id",
  "company_paynl_api_token": "Pay.nl API token",
  "company_paynl_token_code": "Pay.nl API code",
  "company_country": "Land",
  "company_user_impersonate": "Imiteer",
  "user_create": "Nieuwe gebruiker toevoegen",
  "user_language": "Taal",
  "user_create_modal_title": "Nieuwe gebruiker toevoegen aan {name}",
  "user_name": "Naam",
  "user_email": "e-mail adres",
  "user_password": "Wachtwoord",
  "edit_user_modal_title": "Wijzig gebruiker details",
  "user_password_hint": "Laat dit veld leeg als je het wachtwoord niet wilt wijzigen",
  "content_top_welcome_message": "Welkom bij {whitelabel_layout_name}",
  "event_pos_title": "Verkooppunten voor het evenement",
  "event_pos_create": "Toevoegen",
  "pos_modal_create": "Maak een nieuw verkooppunt aan",
  "pos_name": "Naam van het verkooppunt",
  "pos_language": "Taal",
  "pos_url": "URL",
  "pos_modal_edit": "Wijzig verkooppunt",
  "lang_en": "Engels",
  "lang_nl": "Nederlands",
  "lang_de": "Duits",
  "lang_es": "Spaans",
  "event_timeslots": "Tijdsloten",
  "event_timeslot_title": "Beheer jouw tijdsloten: {name}",
  "timeslot_add": "Nieuw tijdslot toevoegen",
  "timeslot_modal_edit": "Wijzig tijdslot",
  "timeslot_modal_create": "Maak een nieuw tijdslot",
  "timeslot_interval": "Interval",
  "timeslot_amount": "Aantal",
  "interval_hourly": "Uurlijks",
  "timeslot_start": "Tijdslot start",
  "timeslot_end": "Tijdslot eind",
  "timeslot_starts_at": "Start",
  "timeslot_ends_at": "Eind",
  "timeslot_date": "Datum",
  "timeslot_saved": "Tijdslot opgeslagen!",
  "timeslot_created": "Tijdslot aangemaakt!",
  "pos_modal_edit_products": "Beschikbare producten voor dit verkooppunt",
  "pos_products_hint": "Vul niets in als je dit product niet in dit verkooppunt wilt aanbieden",
  "pos_payment_methods": "Betalingsmethodes",
  "payment_method": "Betalingsmethode",
  "pos_open": "Koop tickets",
  "pos_event_open": "Open",
  "pos_payment_method_fee_percentage": "Administratiekosten (percentage)",
  "pos_payment_method_fee_fixed": "Administratiekosten (bedrag)",
  "pos_updated": "Verkooppunt opgeslagen!",
  "companies_title": "Beheer bedrijven",
  "companies_create": "Nieuw bedrijf toevoegen",
  "view_pos_minimum_age": "De minimum leeftijd voor dit evenement is {minimum_age}",
  "view_pos_buy": "Koop nu!",
  "pos_product_sold_out": "Uitverkocht",
  "cart_title": "Bestelling overzicht",
  "cart_total": "Totaal",
  "cart_order": "Verder",
  "cart_sub_total": "Sub-total",
  "cart_ticket_fee": "Administratiekosten",
  "cart_empty": "Jouw winkelwagen is momenteel leeg, voeg producten toe",
  "cart_button_hint": "Wij controleren de beschikbaarheid van jouw keuze zodra je op Plaats bestelling klikt",
  "cart_price": "Aantal",
  "customer_company_name": "Bedrijfsnaam",
  "customer_first_name": "Voornaam",
  "customer_last_name": "Achternaam",
  "customer_address": "Adres",
  "customer_zip": "Postcode",
  "customer_city": "Woonplaats",
  "customer_phone": "Telefoonnummer",
  "customer_email": "Email adres",
  "customer_dob": "Geboortedatum",
  "customer_gender": "Geslacht",
  "customer_gender_male": "Man",
  "customer_gender_female": "Vrouw",
  "customer_personal_info": "Personal details",
  "customer_contact_info": "Contact informatie",
  "order_payment_method": "Kies een betalingsmethode",
  "cart_payment_fee": "Betalingskosten",
  "order_continue": "Plaats bestelling",
  "payment_bank": "Kies jouw bank",
  "payment_loading": "Betaling aan het laden...",
  "payment_failed": "Betaling mislukt!",
  "payment_complete": "Betaling gelukt! Je zal de orderbevestiging in jouw mailbox ontvangen!",
  "event_nav_customer_information": "Bezoekersinformatie",
  "event_customerinformation_title": "Beheer de bezoekersinformatie",
  "question_add": "Nieuwe vraag toevoegen",
  "textfield": "Tekstveld",
  "select_box": "Dropdown box",
  "radio_buttons": "Radio buttons",
  "checkboxes": "Checkboxes",
  "customer_information_modal_create": "Voeg een vraag toe",
  "customer_information_question": "Welke vraag wil je stellen",
  "customer_information_question_type": "Soort vraag",
  "customer_information_mandatory": "Invullen verplicht",
  "customer_information_where_to_show": "Waar wil je deze vraag stellen",
  "customer_information_show_order": "Order niveau",
  "customer_information_show_products": "Product niveau",
  "customer_information_modal_edit": "Wijzig vraag: {question}",
  "customer_information_which_products": "Selecteer de producten waarbij je de vraag wilt stellen",
  "customer_information_new_answer": "Nieuw antwoord...",
  "customer_information_saved": "Vraag opgeslagen!",
  "company_name": "Bedrijfsnaam",
  "first_name": "Voornaam",
  "last_name": "Achternaam",
  "address": "Adres",
  "zip": "Postcode",
  "email": "Email",
  "city": "Plaats",
  "country": "Land",
  "dob": "Geboortedatum",
  "mobile": "Mobiel",
  "gender": "Geslacht",
  "customer_information_title_general_questions": "Algemene vragen aan de klant",
  "customer_information_title_specific_questions": "Specifieke vragen aan de klant",
  "dashboard_title": "Welkom!",
  "pos_not_live": "Dit verkooppunt is momenteel niet geopend, probeer later opnieuw",
  "order_loading": "Bestelling aan het laden",
  "event_charge_ticket_fee": "Reken ticket fee door aan jouw klanten",
  "pos_not_found": "Verkooppunt niet gevonden, controleer de link",
  "order_not_found_or_expired": "Bestelling niet gevonden of verlopen",
  "event_continuous": "Doorlopend evenement",
  "discountcode_new_modal_title": "Kortingscode toevoegen",
  "discountcode_code": "Kortingscode",
  "discountcode_create_hint": "Als je de kortingscode hebt aangemaakt, kan je meer gegevens invullen!",
  "discountcode_modal_edit": "Wijzig kortingscode: {code}",
  "discountcode_type": "Soort",
  "discountcode_type_percentage": "Percentage",
  "discountcode_type_value": "Bedrag",
  "discountcode_amount": "Bedrag/Percentage",
  "discountcode_stock": "Totaal beschikbare aantal",
  "discountcode_is_active": "Actief",
  "discountcode_saved": "Kortingscode opgeslagen!",
  "discountcode_starts_at": "Beschikbaar vanaf",
  "discountcode_ends_at": "Beschikbaar tot",
  "pos_custom_css": "Extra CSS",
  "order_id": "Bestelling ID",
  "order_full_name": "Naam klant",
  "order_event": "Evenement",
  "order_created_at": "Aangemaakt op",
  "order_is_paid": "Status betaling",
  "order_details": "Details",
  "order_products": "Bestelde producten",
  "order_customer_details": "Klantgegevens",
  "order_paid": "Bestelling is betaald!",
  "order_not_paid": "Bestelling niet betaald!",
  "order_total": "Totaalbedrag",
  "order_payment_created_at": "Aangemaakt op",
  "order_payment_status": "Status",
  "order_payment_amount": "Betaling",
  "nav_scanners": "Scan center",
  "scanner_add_modal_title": "Nieuwe scanner toevoegen",
  "scanner_name": "Naam",
  "scanner_create_hint": "Gebruik een beschrijvende naam voor uw scanner. Een wachtwoord en login worden automatisch gegenereerd",
  "scanner_show_login_qr": "Toon Login QR Code",
  "scanner_qr_code": "Scan this QR code on the mobile app",
  "close": "Sluiten",
  "scanner_edit": "Wijzig Scanner",
  "scanner_updated": "Scanner is geupdate!",
  "pos_no_group": "Tickets zonder groep",
  "order_notes": "Notities",
  "ticket_not_generated": "Ticket niet aangemaakt!",
  "ticket_generated": "Aangemaakt",
  "ticked_scanned": "Gescand",
  "ticket_view": "Bekijk ticket",
  "ticket_generate": "Maak nieuw ticket",
  "order_create_note": "Maak nieuwe notitie",
  "order_expires_in": "Als je jouw bestelling niet optijd afrondt wordt deze automatisch geannuleerd. Je hebt {timeLeft} om je bestelling af te ronden.",
  "ticket_not_found": "Ticket niet gevonden",
  "order_no_payment_method": "Er is geen betalingsmethode geselecteerd",
  "payment_successful": "Betaling succesvol!",
  "unknown": "Onbekend",
  "email_order_confirmation": "Orderbevestiging verstuurd",
  "audit_show_context": "Toon details",
  "email_content": "Email inhoud",
  "email_ticket_sent": "Ticket verstuurd via de email",
  "assign_tickets_title": "Wie moet de tickets ontvangen?",
  "assign_tickets_hint": "We hebben jouw bestelling ontvangen en je betaling is gelukt! Je moet alleen nog jouw tickets aan bezoekers toewijzen voordat je het bezoek kan afleggen.",
  "assign_tickets_send": "Toewijzen",
  "assign_ticket_self": "aan mijzelf",
  "assign_ticket_sent": "stuur uitnodiging",
  "ticket_claim": "Claim ticket",
  "customer_full_name": "Volledige naam",
  "customer_form_title": "Vul jouw persoonlijke gegevens in",
  "error_try_again": "Er heeft zich een foutmelding voorgedaan, probeer opnieuw",
  "error_select_payment_method": "Selecteer een betalingsmethode",
  "product_type": "Product type",
  "product_is_upsell": "Upsell product zonder E-ticket",
  "product_is_not_upsell": "E-Ticket",
  "product_price": "Prijs",
  "product_stock": "Capaciteit",
  "product_specific_sale_times": "Specifieke verkooptijden",
  "product_no_products": "Er zijn nog geen producten toegevoegd",
  "discountcode_add_to_cart": "Voeg kortingscode toe",
  "discount_code_claim": "Claim",
  "discountcode_invalid": "Deze kortingscode is niet geldig.",
  "cart_discount": "Kortingscode {code}",
  "event_module_name_marketing": "Marketing",
  "event_module_name_organise": "Organiseren",
  "event_print_visitor_list": "Bezoekerslijst",
  "print": "Printen",
  "order_pick_timeslot": "Kies een tijdslot",
  "email_ticket_assigned": "email ticket toegewezen",
  "order_actions": "Acties",
  "order_cancel": "Bestelling annuleren",
  "order_refund": "Bestelling terugbetalen",
  "order_is_cancelled": "Deze bestelling is geannuleerd!",
  "order_cancelled": "Bestelling is geannuleerd",
  "order_log": "Log",
  "order_is_refunded": "Bestelling gerefund",
  "user_added": "Gebruiker toegevoegd!",
  "company_updated": "Bedrijfsgegevens geupdate!",
  "user_role": "rol",
  "user_updated": "Gebruiker details geupdate!",
  "login_invalid": "Verkeerde login, probeer opnieuw",
  "no_product_group": "Producten zonder groep",
  "pos_status": "Status",
  "pos_no_product_category": "Producten zonder categorie",
  "company_invoice_prefix": "Factuur prefix",
  "yes": "Ja",
  "no": "Nee",
  "order_number": "Bestelnummer",
  "order_resend_confirmation": "Tickets opnieuw sturen",
  "optin": "Opt-in email updates",
  "customer_optin": "Ik wil marketing emails van deze organisator ontvangen",
  "customer_optin_iams": "Ja, ik ontvang graag emails vanuit IAMS om kans te maken op toffe prijzen & VIP Experiences",
  "shop_questions_event_hint": "Onze klantenservice staat altijd voor je klaar. Stuur een email of bel het onderstaande nummer!",
  "shop_questions_tickets_hint": "Als je vragen hebt kan je altijd contact opnemen met Fairtix. Stuur een mail of bel het onderstaande nummer!",
  "shop_questions_event": "Vragen over het evenement?",
  "shop_questions_tickets": "Vragen over de tickets?",
  "order_expired": "Jouw bestelling is verlopen, begin opnieuw",
  "layout_settings": "Vormgeving instellingen",
  "layout_primary_color": "Primaire kleur",
  "layout_secondary_color": "Secundaire kleur",
  "layout_secondary_backgroundColor": "Primaire achtergrondkleur",
  "layout_colors": "Vormgeving kleuren",
  "layout_header": "Header",
  "layout_logo": "Logo",
  "layout_header_backgroundColor": "Header achtergrondkleur",
  "company_layout": "Vormgeving instellingen",
  "add": "Toevoegen",
  "layout_updated": "Vormgeving geupdate!",
  "shop_tickets": "Tickets",
  "shop_personal_details": "Persoonlijke gegevens",
  "shop_additional_products": "Extra producten",
  "shop_timeslot": "Tijdsloten",
  "shop_pay": "Betaling",
  "cart_clear": "Winkelwagen legen",
  "invalid_discount_code": "Ongeldige kortingscode",
  "access_denied": "toegang geweigerd",
  "discountcode_already_exists": "Deze kortingscode bestaat al.",
  "end_before_start_date": "Einddatum kan niet eerder zijn dan de startdatum",
  "scanner_token_invalid": "Token voor de scanner is ongeldig",
  "ticket_invalid": "Ticket is ongeldig",
  "ticket_change_owner": "Wijzig eigenaar",
  "product_max_exceeded": "Teveel producten in de bestelling, het aantal zit boven het limiet per bestelling",
  "order_not_paid_error": "Kan de handeling niet voortzetten, de bestelling is niet betaald",
  "product_not_live": "Product staat niet live",
  "product_not_upsell": "Kan product niet toevoegen, het is geen additioneel product",
  "product_out_of_stock": "Product is niet op voorraad",
  "product_create_eticket": "E-ticket aanmaken",
  "product_is_cross_sell": "Toon als cross-sell product",
  "product_stock_unlimited_icon": "∞",
  "product_stock_unlimited_text": "Onbeperkt",
  "product_not_unlimited_stock": "Product heeft geen onbeperkte voorraad",
  "ticket_already_scanned": "Ticket is al gescand",
  "invalid_ticket_entrance": "Verkeerde ingang voor dit ticket",
  "timeslot_event_time_mismatch": "Tijdslot is niet binnen de datum range van het evenement",
  "timeslot_overlap": "Er kunnen geen overlappende tijdsloten gemaakt worden",
  "token_expired": "Sessie verlopen, log opnieuw in",
  "timeslot_too_many_spots": "Kan geen tijdslot maken: Er zijn niet genoeg producten voor dit aantal",
  "assign_tickets_select": "Welke tickets wil je versturen?",
  "assign_tickets_myself": "Wijs aan mijzelf toe",
  "assign_tickets_by_invite": "Stuur uitnodigingen",
  "assign_tickets_continue": "Versturen en verder",
  "tickets_fill_completed": "Tickets toegewezen",
  "tickets_fill_title": "Wijs ticket toe ({todo}/{done})",
  "phone": "Telefoonnummer",
  "customer_fields_saved": "Bezoekers velden opgeslagen",
  "customer_house_nr": "Huisnummer",
  "customer_country": "Land",
  "country_de": "Duitsland",
  "country_nl": "Nederland",
  "country_es": "Spanje",
  "country_be": "België",
  "customer_form_custom_questions": "Beantwoord de volgende vragen",
  "errors_please_select": "Selecteer een optie",
  "order_thank_you": "Bedankt voor jouw bestelling #{order_number}",
  "order_thank_you_text": "Jouw bestelling is compleet.",
  "order_thank_you_btn_ticket_download": "Download tickets",
  "assign_tickets_next": "Volgende",
  "order_status_number": "Jouw bestelling #{order_number}",
  "order_status_event": "Evenement: {name}",
  "order_status_paid": "Betaald",
  "order_status_ticket_not_assigned": "Nog niet op naam gezet",
  "order_status_put_on_name": "Zet op naam",
  "order_status_product_refunded": "Gerefund op {refunded_at}",
  "order_status_product_cancelled": "Geannuleerd",
  "order_status_product_invited_at": "Uitgenodigd op {invited_at}",
  "order_status_ticket_generating": "Ticket wordt gemaakt",
  "order_status_alert_refunded": "Jouw bestelling is volledig gerestitueerd",
  "order_status_alert_cancelled": "Jouw bestelling is geannuleerd",
  "order_status_alert_not_paid": "Jouw betaling is niet doorgekomen of niet geaccepteerd door onze payment service provider, plaats een nieuwe bestelling.",
  "order_status_alert_pending": "Jouw betaling is nog niet doorgekomen, onze payment service provider zal deze betaling handmatig controleren. Dit kan enkele uren duren.",
  "ticket_reminded_at": "Herinnert op",
  "ticket_invited_at": "Uitgenodigd op",
  "ticket_claimed_at": "Geclaimd op",
  "ticket_not_claimed": "Ticket niet geclaimd",
  "ticket_download": "Download ticket",
  "ticket_send_reminder": "Stuur herinnering",
  "ticket_reminder_sent": "Herinnering verstuurd!",
  "customer_email_suggestion": "Bedoelde je {full}?",
  "order_status_your_tickets": "Jouw tickets",
  "order_open_customer_status": "Open klant bestelling pagina",
  "ticket_change": "Wijzig",
  "cart_terms_conditions_first": "Ik ga akkoord met de",
  "cart_terms_conditions": "Door te klikken op de knop 'Verder' bevestigt u dat u de <a href='{url}' target='_blank'>algemene voorwaarden</a> & <a href='https://fairtix.io/nl/privacy-policy' target='_blank'>Privacybeleid</a> van Fairtix gelezen hebt en ermee akkoord gaat.",
  "must_agree_with_tos": "Je dient akkoord te gaan met de algemene voorwaarden om door te gaan.",
  "product_max_buy": "Max per bestelling",
  "product_description": "Omschrijving",
  "actions": "Acties",
  "product_vat_percentage": "BTW %",
  "product_image": "Afbeelding",
  "template_qr": "Positie van de QR code",
  "top": "Top",
  "left": "Links",
  "width": "Breedte",
  "height": "hoogte",
  "template_texts": "Tekst elementen",
  "template_texts_hint": "Je kunt meerdere stukken tekst plaatsen",
  "template_add_text": "Voeg tekstblok toe",
  "template_background": "Achtergrond afbeelding",
  "template_save": "Template opslaan",
  "generate_preview": "Download voorbeeld",
  "nav_ticket_templates": "Ticket templates",
  "ticket_template_background": "Achtergrond afbeelding",
  "template_background_hint": "Het bestand moet in JPG formaat zijn met een afmeting van 1240 x 1755 pixels en een resolutie van 72 dots per inch",
  "customer_gender_other": "Anders",
  "ticket_template_updated": "Ticket template updated!",
  "template_text_block": "Tekst",
  "template_position_hints": "De pagina heeft 595 bij 842 'points', alles buiten deze range wordt niet getoond",
  "ticket_template_name": "Naam template",
  "error_name": "Ongeldige naam",
  "event_ticket_template": "Ticket template",
  "event_has_donation_product": "Evenement kan niet meer dan één donatieproduct hebben",
  "whatsapp_message": "Claim jouw ticket voor {event} hier: {link}",
  "event_updated": "Evenement details geupdate!",
  "event_not_live": "Het evenement is nog niet geopend voor verkopen, probeer later opnieuw",
  "event_is_archived": "Het evenement is gearchiveerd en kan niet meer worden bewerkt",
  "event_passed": "Het evenement staat niet online",
  "product_sale_starts_at": "Verkoop start op",
  "product_sale_ends_at": "Verkoop eind op",
  "error_page_not_found": "Pagina niet gevonden",
  "create_template": "Maak template",
  "template_modal_create": "Maak een nieuw template",
  "template_name": "Naam",
  "error_is_upsell": "Kies je product type",
  "error_vat_percentage": "Vul in een BTW percentage",
  "error_price": "Vul in een prijs",
  "error_stock": "Vul een voorraad in",
  "error_status": "Kies een status",
  "ticket_confirmation_resent": "Tickets zijn opnieuw gestuurd!",
  "layout_cart": "Winkelwagen layout",
  "layout_cart_backgroundcolor": "Achtergrondkleur",
  "layout_cart_color": "Tekstkleur",
  "layout_cart_product_title_color": "Product titel kleur",
  "layout_cart_product_subtext_color": "Product ondertitel kleur",
  "layout_cart_product_price_color": "Product prijs kleur",
  "layout_cart_button_backgroundColor": "Knop achtergrond kleur",
  "layout_cart_button_color": "Knop kleur",
  "layout_cart_sidebar": "Winkelwagen sidebar",
  "layout_cart_sidebar_backgroundColor": "Achtergrond kleur",
  "layout_cart_sidebar_color": "Tekst kleur",
  "layout_cart_sidebar_button_backgroundColor": "Knop achtergrond kleur",
  "layout_cart_sidebar_button_color": "Knop tekst kleur",
  "layout_cart_product_group_backgroundColor": "Groep achtergrond kleur",
  "layout_cart_product_group_textColor": "Groep tekst kleur",
  "layout_top_bar": "Top bar layout",
  "layout_top_bar_title_color": "Titel kleur",
  "layout_stepper_backgroundColor": "Stepper achtergrond kleur",
  "layout_stepper_color": "Stepper tekst kleur",
  "layout_info_blocks": "Info blokken layout",
  "layout_info_blocks_titleColor": "Titel kleur",
  "layout_info_blocks_color": "Tekst kleur",
  "layout_info_blocks_backgroundColor": "Achtergrond",
  "layout_stepper_done_backgroundColor": "Stepper klaar achtergrond kleur",
  "layout_stepper_done_color": "Stepper klaar tekst kleur",
  "view_pos_title": "Product overzicht voor {event_name}",
  "pos_personal_details_title": "Persoonlijke gegevens",
  "pos_timeslot_title": "Tijdsloten overzicht",
  "pos_payment_method_title": "Betalingsmethodes",
  "pos_allow_donation_question": "Donaties toestaan?",
  "order_view_order_details_title": "Wijs je tickets toe",
  "order_view_assign_title": "Wijs je tickets toe",
  "order_thank_you_title": "Bedankt",
  "order_status_title": "Bestelling overzicht",
  "ticket_changed": "Ticket gewijzigd!",
  "ticket_changed_text": "Het ticket is gewijzigd en wordt verstuurd via de mail. ",
  "view_pos_cart_title": "Kies jouw tickets",
  "tickets_assigned_email_sent": "Invite email successfully sent!",
  "backend_title_login": "Fairtix Controle Panel",
  "backend_title_dashboard": "Dashboard",
  "backend_title_order_overview": "Bestelling overzicht",
  "backend_title_order_detail": "Bestelling details {order_number}",
  "backend_title_events_overview": "Evenementen overzicht",
  "backend_title_events_manage": "Evenementen beheren",
  "backend_title_events_products": "Evenement producten",
  "backend_title_events_timeslots": "Evenement tijdsloten",
  "backend_title_events_customer_information": "Evenement bezoekersinformatie",
  "backend_title_events_pos": "Verkooppunten voor het evenement",
  "backend_title_events_visitor_list": "Evenement bezoekerslijst",
  "backend_title_reports": "Rapporten",
  "backend_title_discountcodes": "Kortingscode overzicht",
  "backend_title_ticket_templates": "Ticket templates",
  "backend_title_edit_ticket_templates": "Wijzig ticket template",
  "backend_title_manage_company": "Beheer bedrijf",
  "report_genders_unkown": "Onbekend",
  "report_genders_f": "Vrouw",
  "report_genders_m": "Man",
  "report_genders_o": "Anders",
  "report_cities_unkown": "Onbekend",
  "report_paid_orders": "Betaalde bestellingen",
  "report_tickets_sold": "Tickets uitgegeven",
  "report_tickets_claimed": "Tickets geclaimed",
  "report_total_revenue": "Totale omzet",
  "report_sales_per_day": "Verkopen per dag",
  "report_sales_per_day_cumulative": "Verkopen cumulatief",
  "report_tickets_sold_per_type": "Verkochte tickets per soort",
  "report_gender": "Geslachtratio",
  "report_cities": "Woonplaats bezoeker",
  "report_payment_methods": "Betalingsmethodes",
  "report_tickets": "Tickets",
  "report_age": "Verkochte tickets per leeftijd",
  "report_event": "Evenement",
  "report_date_range_start": "Startdatum",
  "report_date_range_end": "Einddatum",
  "report_filter_btn": "Filter",
  "ticket_templates": "Ticket templates",
  "ticket_customer_not_set": "Klant niet gevonden",
  "order_payment_pending": "Wanneer jouw betaling is aangekomen sturen wij je een email met een link om jouw tickets te claimen.",
  "export_orders": "Bestellingen exporteren",
  "language_en": "Engels",
  "language_de": "Duits",
  "language_nl": "Nederlands",
  "export_event_name": "Evenement",
  "export_order_number": "Bestelnummer",
  "export_total_price": "Totaalprijs",
  "export_discount": "Korting",
  "export_order_payment_fee": "Betalingsmethode administratiekosten",
  "export_order_payment_fee_vat": "Betalingsmethode administratiekosten BTW",
  "export_order_payment_fee_vat_perc": "Betalingsmethode administratiekosten BTW %",
  "export_ticket_fee_total": "Ticket administratiekosten",
  "export_ticket_fee_vat": "Ticket administratiekosten BTW",
  "export_ticket_fee_vat_perc": "Ticket administratiekosten BTW %",
  "export_product_number": "Productnummer",
  "export_product_price": "Product prijs",
  "export_product_price_vat": "Product prijs BTW",
  "export_product_price_vat_perc": "Product prijs BTW %",
  "export_product_service_fee": "Product administratiekosten",
  "export_product_service_fee_vat": "Product administratiekosten BTW",
  "export_product_service_fee_vat_perc": "Product administratiekosten BTW %",
  "export_order_payment_method": "Betalingsmethode",
  "export_customer_first_name": "Klant voornaam",
  "export_customer_last_name": "Klant achternaam",
  "export_customer_company_name": "Klant bedrijfsnaam",
  "export_customer_email": "Klant email",
  "export_customer_address": "Klant adres",
  "export_customer_zip": "Klant postcode",
  "export_customer_city": "Klant plaats",
  "export_customer_country": "Klant land",
  "export_customer_gender": "Klant geslacht",
  "export_customer_optin": "Klant optin",
  "export_customer_phone": "Klant telefoonnummer",
  "export_product_id": "Product id",
  "export_product_group": "Product groep",
  "export_product_name": "Product naam",
  "export_product_type": "Product type",
  "orders_export": "Exporteer bestellingen naar CSV",
  "export_settings_from": "Begin datum",
  "export_settings_to": "Eind datum",
  "export_settings_fields": "Velden te exporteren",
  "export_settings_check_all": "Selecteer alle velden",
  "orders_export_make": "Maak export",
  "error_from": "Geen start datum geselecteerd",
  "error_to": "Geen eind datum geselecteerd",
  "error_fields": "Geen velden geselecteerd",
  "timeslot_deleted": "Tijdslot verwijdert!",
  "timeslot_already_in_orders": "Kan dat tijdslot niet verwijderen, er is een bestelling met dit tijdslot",
  "max": "Max",
  "not_set": "Niet ingesteld",
  "template_title": "Wijzig template: {name}",
  "order_discount": "Korting",
  "ticket_cancelled": "Gecancelled",
  "order_status_cancelled": "Gecancelled",
  "order_status_refunded": "Gerefund",
  "ticket_cancel": "Annuleer",
  "order_detail_ticket_cancelled": "Ticket succesvol gecanceld",
  "order_detail_modal_cancel_order_title": "Bestelling annuleren: #{order}",
  "order_detail_order_cancelled": "Bestelling geannuleerd",
  "order_detail_cancel_order": "Bestelling annuleren",
  "order_detail_cancel_order_confirmation": "Weet je zeker dat je deze bestelling wilt annuleren?",
  "order_detail_modal_refund_order_title": "Restitutie bestelling: #{order}",
  "order_detail_refund_order_confirmation": "Weet je zeker dat je deze bestelling wilt refunden?",
  "order_detail_refund_order": "Betaal terug",
  "order_detail_refund_order_amount": "Amount",
  "order_detail_refund_greater_error": "Amount should not be greater than: ",
  "order_detail_refund_less_error": "Amount should be positive",
  "order_refund_invalid_amount_error": "Invalid amount",
  "order_detail_order_refunded": "Bestelling is succesvol gerefund",
  "order_detail_modal_resent_tickets_title": "Stuur tickets opnieuw: #{order}",
  "order_detail_resent_tickets_confirmation": "Weet je zeker dat je de tickets opnieuw wilt sturen?",
  "order_detail_resent_confirmation_tickets": "Stuur tickets",
  "payment_started": "Transactie begonnen",
  "order_refunded": "Bestelling teruggestort",
  "order_detail_modal_send_mail": "Informeer de klant door een email",
  "order_detail_mail_receiver": "Ontvanger",
  "order_detail_mail_subject": "Onderwerp",
  "order_detail_mail_message": "Bericht",
  "mail_subject_cancel_order": "{first_name}, jouw bestelling is geannuleerd",
  "email_order_cancelled": "Bestelling geannuleerd",
  "mail_subject_refund_order": "{first_name}, jouw order wordt teruggestort",
  "email_order_refunded": "Bestelling teruggestort",
  "order_customer_answers": "Klant antwoorden",
  "delete_entry": "Weet u zeker dat u deze gegevens wilt verwijderen?",
  "product_had_been_ordered": "Het product is besteld",
  "product_modal_delete": "Verwijder product",
  "product_delete_confirmation": "Weet u zeker dat u deze gegeven wilt verwijderen?",
  "product_has_been_deleted": "Product has been deleted",
  "event_event_type": "Soort evenement",
  "user_role_user": "Gebruiker",
  "user_role_company_admin": "Bedrijf admin",
  "order_detail_payment_method": "Betalingsmethode",
  "pos_in_test_mode": "Dit verkooppunt is in TEST mode",
  "order_test_paid": "Test bestelling",
  "product_successfully_ordered": "Succes",
  "manage_company_without_vat": "Deze prijzen zijn zonder BTW",
  "product_calculate_service_fee": "Administratiekosten doorberekenen aan klant",
  "product_companies_ticket_fee": "De ticket fee voor uw bedrijf is €{ticket_fee_incl} incl BTW",
  "order_overview_show_expired": "Toon verlopen bestellingen",
  "scan_operation_manage": "Manage",
  "scan_start_date": "Start",
  "scan_start_time": "Start",
  "scan_end_date": "Eind",
  "scan_end_time": "Eind",
  "scanner_description": "Omschrijving (Bijv: Hoofd ingang)",
  "scan_operation_session_modal_delete": "Verwijder sessie bevestiging",
  "scan_operation_session_name": "Sessie naam",
  "scan_operation_session_modal_edit": "Wijzig sessie details",
  "scanner_modal_delete": "Verwijder scanner",
  "scanner_username": "Gebruikersnaam",
  "scanner_password": "Wachtwoord",
  "session_name": "Sessie naam",
  "scanner_modal_edit": "Wijzig scanner details",
  "next": "Volgende",
  "scan_sessions": "Scan sessies",
  "scan_enable_outgoing_hint": "Scan bezoeker bij het verlaten",
  "scan_enable_outgoing": "Uitgaande scans inschakelen",
  "scan_test_mode_hint": "Inschakelen testmodus",
  "scan_test_mode": "Test modus",
  "scanner_manage_title": "De scannergegevens beheren",
  "nav_scan_operations": "Scan operaties",
  "previous": "Vorige",
  "scan_operation_session_configure_products": "Producten configureren",
  "sessions": "Sessies",
  "scan_operation_products": "Producten",
  "scan_operation_session_configure_scanners": "Scanners configureren",
  "finish": "Finish",
  "scan_operation_overview_event": "Evenement: {event_name}",
  "scan_operation_overview_outgoing_scans": "Uitgaande scans:",
  "scan_operation_overview_outgoing_test_mode": "Test modus:",
  "scan_operation_overview_outgoing_enabled": "Ingeschakeld",
  "scan_operation_overview_outgoing_disabled": "Uitgeschakeld",
  "scan_operation_overview_outgoing_false": "Onwaar",
  "scan_operation_overview_outgoing_true": "Waar",
  "scan_operation_overview_scanners": "Scanners",
  "scan_operation_overview_sessions": "Sessies",
  "scan_operation_overview_edit": "Wijzigen",
  "scan_operation_overview_product_configuration": "Product configuratie",
  "scan_operation_overview_scanner_configuration": "Scanner configuratie",
  "scan_operation_overview_for": "Scan operatie overzicht voor: {event_name}",
  "backend_title_scan_operation_manage": "Beheer scan operatie",
  "backend_title_scan_operation_summary": "Scan operatie overzicht",
  "backend_title_scan_operation_product_configuration": "Product configuratie",
  "backend_title_scan_operation_scanner_configuration": "Scanner configuratie",
  "date_format": "dd-mm-yyyy",
  "export_no_results": "Er zijn geen resultaten gevonden binnen dit tijdsframe",
  "ticket_customer_not_assigned": "Tickethouder niet toegewezen",
  "copy_ticket_link": "Kopieer link",
  "ticket_assign": "Ticket toewijzen",
  "ticket_assigned_explenation": "{customer_first_name} heeft een ticket voor jou gekocht voor het evenement {event_name}. Claim je ticket door het onderstaande formulier in te vullen.",
  "scan_operation_event": "Evenement",
  "scan_operation_status": "Status",
  "scan_operation_users": "Aantal scanners",
  "scan_operation_actions": "Acties",
  "scan_operation_add_modal_title": "Maak scan operatie",
  "select_event": "Evenement",
  "scan_operation_create_hint": "Kies het evenement waarvoor je een scan operatie wilt maken",
  "event_module_name_box_offices": "Box offices",
  "event_nav_box_offices": "Box offices",
  "event_box_office_create": "Maak nieuwe box office",
  "event_box_office_create_name": "Box office naam",
  "event_box_office_name": "Box offices",
  "event_box_office_modal_edit": "Wijzig box office",
  "event_box_office_products": "Selecteer de producten die getoond worden",
  "event_box_office_payment_methods": "Selecteer de betalingsmethodes die getoond worden",
  "box_office_updated": "Box office succesvol gewijzigd",
  "event_box_office_check_overrule": "Overrule prijs",
  "user_box_office": "Is box office",
  "box_office_choose_event_title": "Kies een evenement waar je de box office voor wilt starten",
  "box_office_choose_box_office_title": "Kies de box office die je wilt starten voor het evenement: {event_name}",
  "box_office_place_order_price": "Prijs",
  "box_office_place_order_available": "Beschikbaar",
  "box_office_place_order_sold_out": "Uitverkocht",
  "box_office_place_order_save_settings_success": "Success",
  "box_office_place_order_customer_details": "Klant details",
  "box_office_place_order_fill_customer_details": "Vul de klantgegevens in",
  "box_office_place_order_choose_payment": "Kies de gewenste betalingsmethode",
  "box_office_place_order_payment_pin": "Pin",
  "box_office_place_order_payment_cash": "Contant",
  "box_office_place_order_discount_enter": "Enter",
  "box_office_place_order_remove_discount": "Verwijder korting",
  "box_office_place_order_empty_cart": "Winkelwagen legen",
  "box_office_place_order_amount_of_products": "Aantal producten:",
  "box_office_place_order_subtotal": "Subtotaal:",
  "box_office_place_order_total": "Totaal:",
  "box_office_place_order_discount": "Korting:",
  "box_office_place_order_which_product_to_show": "Welke producten wil je tonen",
  "box_office_place_order_place_order": "Bestelling plaatsen",
  "event_default_group": "Default Group",
  "event_box_office_use_all_stock": "Gebruik voorraad van niet verkochte tickets",
  "box_office_place_order_customer_has_to_pay": "Klant moet betalen",
  "box_office_place_order_given_by_customer_in": "Gegeven bij klant in",
  "box_office_place_order_return_to_customer_in": "Teruggeven aan klant in",
  "cart_product": "Product",
  "box_office_order_history_order_number": "Ordernummer",
  "box_office_order_history_order_placed": "Bestelling geplaatst",
  "box_office_order_history_payment_method": "Betalingsmethode",
  "box_office_order_history_customer": "Klant",
  "box_office_order_history_products": "Producten",
  "box_office_order_history_total_price": "Totaalprijs",
  "unkown": "Onbekend",
  "add_discount": "Add discount",
  "box_office_place_save_settings_success": "Wijzigingen opgeslagen",
  "order_overview_box_office": "Box office",
  "order_overview_online": "Online",
  "order_type": "Soort bestelling",
  "box_office_order_history_title": "Bestelling geschiedenis",
  "box_office_place_order_discount_to_high": "Korting mag niet groter dan het totaalbedrag zijn",
  "event_show_archived": "Toon gearchiveerde evenementen",
  "order_overview_show_box_office_orders": "Toon bestellingen aan kassa",
  "report_box_office": "Voeg bestellingen per kassa toe",
  "export_to_email": "Stuur export naar:",
  "error_email": "Email is verplicht",
  "export_order_success": "Zodra jouw download klaar is wordt de link naar het ingevuld email adres toegestuurd",
  "role_is_required": "Rol is verplicht",
  "password_is_required": "Wachtwoord is verplicht",
  "email_is_required": "Email is verplicht",
  "username_is_required": "Gebruikersnaam is verplicht",
  "box_office_no_payment_method_chosen": "Geen betalingsmethode gekozen",
  "box_office_no_products_chosen": "Geen producten gekozen",
  "product_remove_image": "Afbeelding verwijderen",
  "order_details_edit_customer_data": "Wijzigen klantgegevens",
  "order_details_edit_customer_success_message": "Klantgegevens zijn gewijzigd",
  "customer_already_exists": "Klant bestaat al",
  "scan_operation_show_archived": "Toon gearchiveerde scanoperaties",
  "no_results_have_been_found": "Er zijn geen resultaten gevonden",
  "error_ticket_template_id": "Er is geen ticket template gekozen",
  "test_payment": "Test betaling",
  "layout_top_bar_date_color": "Datum text kleur",
  "layout_stepper_hint_color": "Hint text kleur",
  "order_ticket_scanned_at": "Gescand om",
  "order_ticket_not_yet_scanned": "Nog niet gescand",
  "pos_product_expired": "Verlopen",
  "product_min_buy": "Min per bestelling",
  "product_amount_is_less_than_minimum_amount": "Producthoeveelheid is kleiner dan minimumhoeveelheid",
  "min_buy_should_be_less_than_max_buy": "Minimumaankoop moet lager zijn dan maximumaankoop",
  "product_multi_day_ticket": "Meerdaags ticket",
  "dashboard_events_tickets_sold": "Tickets inclusief {guest_list_number} gastenlijst",
  "dashboard_events_today": "Vandaag",
  "dashboard_events_last_7_days": "Laatste 7 dagen",
  "dashboard_events_total_revenue": "Totale omzet:",
  "duplicate": "Dupliceren",
  "event_duplicate_event": "Dupliceer evenement",
  "event_new_name": "Nieuwe naam evenement",
  "event_duplicate_choose_products_to_copy": "Kies welk(e) product(en) u wilt kopiëren",
  "event_duplicate_point_of_sales": "Verkooppunten URLs",
  "select_all": "Kies alle",
  "unselect_all": "Alles deselecteren",
  "event_scan_operation_session_date_to_change": "Datum en tijd van de scanbewerking moeten worden gewijzigd",
  "event_name_has_to_be_changed": "De naam van het evenement moet worden veranderd",
  "customer_support_free_search": "Gratis zoeken",
  "customer_support_search": "Zoeken",
  "customer_support_reset_filter": "Filter resetten",
  "customer_support_filters": "Filters",
  "customer_support_company": "Bedrijf:",
  "customer_support_event": "Evenement:",
  "customer_support_payment_status": "Status van betaling:",
  "customer_support_center": "Centrum voor klantenondersteuning",
  "order_status_new": "Nieuw",
  "order_status_pending": "Pending",
  "user_role_customer_support": "Klantenondersteuning",
  "no_data_to_show": "Geen gegevens om aan te tonen",
  "submit": "Submit",
  "pos_show_in_overview": "Toon verkooppunt in evenementen overzicht",
  "login_username": "Gebruikersnaam",
  "scan_operation_terminal_button": "Scan terminal",
  "scanner_terminal_event": "Scan terminal voor",
  "dashboard_events_scans": "Scans:",
  "dashboard_total_visitors_inside": "Bezoekers binnen",
  "dashboard_scanned": "Gescand",
  "dashboard_left_to_scan": "Te scannen",
  "dashboard_box_office_entries": "Deurverkoop",
  "opening_hours_hourly": "Uurlijks",
  "opening_hours_all_day": "Gehele dag",
  "opening_hours_create": "Voeg openingstijden toe",
  "opening_hours_day_of_week": "Dag",
  "opening_hours_opens_at": "Opent vanaf",
  "opening_hours_closes_at": "Sluit om",
  "opening_hours_spots": "Plekken",
  "opening_hour_interval": "Interval",
  "opening_hour_create": "Nieuw",
  "edit_opening_hours_day": "Wijzigen openingsuren voor dag",
  "opening_hours_adjust": "Wijzig dag",
  "day_adjusted": "Openingstijden gewijzigd voor dag",
  "event_timeslots_actions": "Acties",
  "error_opens_at": "Opent vanaf is niet juist ingevuld",
  "error_closes_at": "Sluit om is niet juist ingevuld",
  "error_spots": "Het aantal plekken is niet ingevuld",
  "error_interval": "Interval is niet gekozen",
  "order_pick_date": "Kies jouw datum",
  "order_timeslot": "Tijdslot",
  "invalid_opening_hour": "Verkeerde openingstijden",
  "event_ticket_template_product_tooltip": "Het kiezen van een sjabloon heft de standaard ticketsjabloon op die is geconfigureerd voor het evenement voor dit specifieke product.",
  "company_show_kvk_on_pos": "Toon KVK in shop",
  "shop_chamber_of_commerce_number": "KVK nummer",
  "my_company_invoice_title": "Instellingen automatisch factureren",
  "my_company_invoice_automatic_invoicing": "Automatisch factureren",
  "my_company_invoice_automatic_invoicing_test_mode": "Test modus (Geen uitbetalingen)",
  "my_company_invoice_vat_shifted": "Maak factuur BTW verlegd",
  "my_company_invoice_anti_dating": "Anti dateer Pay.nl uitbetalingen",
  "my_company_invoice_include_payout_summary": "Uitbetaling samenvattend verslag toevoegen",
  "my_company_invoice_include_fairtix_invoice": "Fairtix-factuur voor klant toevoegen",
  "my_company_invoice_generate_fairtix_invoice": "Genereer Fairtix factuur voor klant",
  "my_company_invoice_include_detailed_explanation": "Voeg een gedetailleerd uitbetalingsoverzicht toe",
  "my_company_invoice_generate_detailed_explanation": "Genereer gedetailleerd uitbetalingsoverzicht",
  "my_company_invoice_set_off_invoices": "Uitbetalingsfactuur verrekenen met Fairtix-factuur",
  "my_company_invoice_generate_payout_summary": "Genereer uitbetalingsoverzicht",
  "my_company_invoice_payout_frequency": "Uitbetaling frequentie",
  "my_company_invoice_max_payment_period": "Max. betalingstermijn (in dagen)",
  "my_company_invoice_payout_delay": "Uitstel van uitbetaling na event (in dagen)",
  "my_company_invoice_receive_method": "Ontvangmethode",
  "event_deleted": "Evenement verwijderd!",
  "event_has_orders": "Evenement heeft orders",
  "pos_overview_read_less": "Minder lezen",
  "pos_overview_read_more": "Meer lezen",
  "manage_event_image": "Afbeelding (530x340 pixels)",
  "manage_event_remove_image": "Afbeelding verwijderen",
  "manage_event_image_tooltip": "Deze afbeelding zal worden getoond in het evenementen overzicht",
  "pos_sale_ends_in_days_and_hours": "Verkoop eindigt over {days} dag(en) en {hours} uur",
  "pos_sale_ended_at": "Verkoop geëindigd op",
  "pos_sale_ends_in_hours": "Verkoop eindigt in {hours} uur",
  "ticket_claim_copy_order_data": "Kopieer persoonsgegevens van bestelling",
  "template_background_jpg_hint": "Enkel JPG's zijn toegestaan als achtergrondafbeelding",
  "company_settings": "Instellingen",
  "company_send_order_notifications": "Verzend ordermeldingen",
  "company_send_order_notifications_email": "E-mailadres waarop u meldingen wilt ontvangen",
  "reports_include_archived_events": "Toon gearchiveerde evenementen",
  "pos_sale_ends_in_minutes": "Verkoop eindigt in {minutes} minuten",
  "pos_sale_ends_in_months_days_and_hours": "Verkoop eindigt in {months} maand(en), {days} dag(en) en {hours} uur",
  "pos_sale_ends_in_months_days": "Verkoop eindigt in {months} maand(en) en {days} dag(en)",
  "pos_sale_ends_in_months": "Verkoop eindigt in {months} maand(en)",
  "dashboard_sold_tickets": "Verkochte tickets voor: {event}",
  "add_attendees": "Deelnemers toevoegen",
  "guest_list_add_attendees": "Verstuur gastenlijst tickets",
  "guest_list_choose_tickets": "Kies de tickets",
  "guest_list_total_worth": "Totaalbedrag:",
  "guest_list_total_items": "Aantal tickets:",
  "guest_list_order_data": "Bestelgegevens",
  "quest_list_populate_tickets_with_customer_data": "Tickets vullen met klantgegevens",
  "guest_list_todo_next_send_invite_to_claim_tickets": "Stuur uitnodiging om tickets te claimen",
  "guest_list_todo_next_send_invite_to_claim_tickets_description": "De besteller ontvangt een e-mail met een link waar alle tickets kunnen worden toegewezen en opgeëist",
  "guest_list_todo_next_send_all_tickets_to_order_owner": "Stuur alle tickets naar de eigenaar van de bestelling",
  "guest_list_todo_next_send_all_tickets_to_order_owner_description": "De besteller ontvangt een e-mail waarin alle tickets als afzonderlijke PDF's zijn bijgevoegd",
  "guest_list_todo_next_place_order_without_sending_tickets": "Bestelling plaatsen zonder tickets te sturen",
  "guest_list_todo_next_place_order_without_sending_tickets_description": "De bestelling wordt geplaatst zonder dat er tickets worden verstuurd",
  "guest_list_no_payment_needed": "Geen betaling nodig",
  "guest_list_paid_with_cash": "Betaalt contant",
  "guest_list_send_order_confirmation": "Stuur orderbevestiging per e-mail",
  "guest_list_order_saved_successfully": "Tickets succesvol toegevoegd",
  "guest_list_order_saved_successfully_desc": "De bestelling is aangemaakt en de tickets zijn daar aan toegevoegd. De opgegeven persoon heeft een mail ontvangen met de gegevens.",
  "guest_list_not_all_customer_details_filled": "Alle ontvanger gegevens moeten worden ingevuld",
  "order_overview_free_tickets": "Gratis bestelling",
  "order_overview_manual_orders": "Handmatige bestelling",
  "place_order_without_tickets": "Geplaatste bestelling zonder tickets te versturen",
  "guest_list_tickets_claim_invite": "Ticket claim uitnodiging verstuurd",
  "guest_list_payment_terms": "Wat wil je met de betaling doen?",
  "guest_list_what_next": "Wat wil je doen?",
  "guest_list_order_confirmation_with_tickets_and_payment": "Orderbevestiging sturen van toegevoegde bezoekers",
  "guest_list_order_confirmation_with_tickets": "Orderbevestiging sturen van toegevoegde bezoekers",
  "guest_list_order_confirmation_with_payment": "Orderbevestiging sturen van toegevoegde bezoekers",
  "guest_list_order_confirmation": "Orderbevestiging sturen van toegevoegde bezoekers",
  "multi_tickets_created": "Tickets zijn verstuurd",
  "guest_list_send_all_tickets_to_order_owner": "Tickets zijn naar de eigenaar van de bestelling gestuurd",
  "guest_list_send_tickets_to_ticket_holders": "Ticket is direct naar een tickethouder gestuurd",
  "guest_list_todo_next_send_payment_link": "Verstuur een betaalverzoek per mail",
  "guest_list_todo_next_send_payment_link_description": "De ontvanger krijgt een mail met daarin een verzoek om te betalen. Zodra de betaling is ontvangen, worden de tickets verstuurd.",
  "ticket_created": "Ticket is verstuurd",
  "event_name_64_char": "De naam van het evenement mag niet minder dan 4 tekens of langer dan 64 tekens zijn",
  "report_orders_grouped_by_tickets": "Bestellingen gegroepeerd op aantal tickets",
  "report_tickets_per_order": "Tickets per bestelling",
  "report_number_of_orders": "Aantal bestellingen",
  "report_order_placed": "Geplaatste bestelling",
  "report_ticket_type": "Type ticket",
  "report_tickets_selected": "Ticket(s) geselecteerd",
  "report_select_ticket": "Kies ticket",
  "ticket_is_required": "Tickets veld is verplicht",
  "reset_password": "Reset uw wachtwoord",
  "password_reset_successfully": "Wachtwoord is succesvol gereset",
  "password_confirmation": "Wachtwoord bevestiging",
  "company_user_reset_password_checkbox": "Laat gebruiker wachtwoord resetten bij login",
  "password_not_match": "Wachtwoorden komen niet overeen",
  "password_reset_user_should_reset_password": "U dient het wachtwoord opnieuw in te stellen",
  "ticket_secret": "Ticketnummer",
  "scanner_terminal_showing_of_entries": "Het tonen van {per_page} van {total} inzendingen",
  "scanner_terminal_search": "Zoeken",
  "scanner_terminal_filter_btn": "Filter",
  "scanner_terminal_btn_check_in": "Inchecken",
  "ticket_unclaimed_reminding": "Ticket claim reminder",
  "order_refund_choose_which_products_to_refund": "Kies welke producten je wilt terugbetalen",
  "order_refund_include_ticket_fees": "Neem ticket administratiekosten van {total} mee in de terugbetaling",
  "order_refund_include_payment_fees": "Neem betaling administratiekosten {total} mee in de terugbetaling",
  "order_refund_total_amount": "Totaal bedrag te refunden:",
  "order_refund_total_bigger_paid": "Het totale bedrag dat gerefund wordt mag niet groter dan het totale bedrag van de bestelling zijn",
  "could_not_process_payment": "Kan betaling niet verwerken",
  "company_refund_fee": "Fee per refund",
  "nav_master_data": "Stamgegevens",
  "roles_roles_permissions": "Rol Machtigingen",
  "roles_permission_roles": "Machtiging Rollen",
  "roles_name": "Naam",
  "roles_admin_only": "Alleen admin",
  "roles_online": "Online",
  "roles_created_by": "Aangemaakt door",
  "role_saved_successfully": "Rol succesvol opgeslagen",
  "role_deleted_successfully": "Rol succesvol verwijderd",
  "company_permissions": "Bedrijfsmachtigingen",
  "company_user_settings_tab": "Instellingen gebruiker",
  "company_permissions_tab": "Rechten",
  "not_have_permission": "Je hebt geen toestemming om deze pagina te openen",
  "permission_order_overview_view": "Overzicht van bestellingen",
  "permission_stock_report_view": "Overzicht voorraadrapporten",
  "permission_admin_company_overview_view": "Admin bedrijfsoverzicht bekijken",
  "permission_admin_company_payment_costs_view": "Admin bedrijf betalingskosten bekijken",
  "permission_admin_company_payment_costs_edit": "Admin bedrijf betaalkosten bewerken",
  "permission_admin_company_payment_costs_create": "Admin bedrijf betalingskosten toevoegen",
  "permission_admin_company_user_impersonate": "Admin bedrijfs gebruiker imiteren",
  "permission_admin_company_details_view": "Bedrijfsgegevens administrateur bekijken",
  "permission_admin_company_details_edit": "Admin bedrijfsgegevens bewerken",
  "permission_order_overview_export": "Orderoverzicht exporteren",
  "permission_order_overview_search": "Besteloverzicht zoeken",
  "permission_order_detail_view": "Order detailweergave",
  "permission_order_cancel": "Bestelling annuleren",
  "permission_order_refund": "Bestelling terugbetalen",
  "permission_order_order_confirmation": "Orderbevestiging",
  "permission_order_detail_product_cancel": "Besteldetail product annuleren",
  "permission_order_detail_product_change_owner": "Besteldetail product wijzigen eigenaar",
  "permission_order_detail_change_customer_details": "Besteldetail klantgegevens wijzigen",
  "permission_add_attendees_view": "Aanwezigen toevoegen",
  "permission_event_overview_view": "Overzicht evenement",
  "permission_event_create": "Evenement aanmaken",
  "permission_event_delete": "Evenement verwijderen",
  "permission_event_duplicate": "Evenement dupliceren",
  "permission_event_details_view": "Evenement details bekijken",
  "permission_event_details_edit": "Details van evenement bewerken",
  "permission_event_products_view": "Evenement producten bekijken",
  "permission_event_products_edit": "Evenement producten bewerken",
  "permission_event_products_delete": "Evenementproducten verwijderen",
  "permission_event_products_create": "Evenementproducten aanmaken",
  "permission_event_timeslot_view": "Evenement timeslot bekijken",
  "permission_event_customer_information_view": "Evenement klantinformatie bekijken",
  "permission_event_customer_information_edit": "Evenement klantinformatie bewerken",
  "permission_event_point_of_sale_view": "Evenement verkooppunt bekijken",
  "permission_event_point_of_sale_create": "Evenement verkooppunt maken",
  "permission_event_point_of_sale_edit": "Evenement verkooppunt bewerken",
  "permission_reports_view": "Rapporten bekijken",
  "permission_reports_sales_by_tickettype_view": "Rapporten verkoop per tickettype weergeven",
  "permission_discountcode_view": "Weergave kortingscode",
  "permission_discountcode_create": "Kortingscode maken",
  "permission_discountcode_edit": "Kortingscode bewerken",
  "permission_scan_operation_view": "Scanoperatie bekijken",
  "permission_scan_operation_create": "Scanoperatie aanmaken",
  "permission_scan_operation_edit": "Scanoperatie bewerken",
  "permission_ticket_template_view": "Ticket template bekijken",
  "permission_ticket_template_create": "Ticketsjabloon maken",
  "permission_ticket_template_edit": "Ticket sjabloon bewerken",
  "permission_my_company_view": "Mijn bedrijf bekijken",
  "permission_my_company_user_create": "Mijn bedrijfsgebruiker aanmaken",
  "permission_my_company_user_edit": "Mijn bedrijfsgebruiker bewerken",
  "permission_my_company_user_delete": "Mijn bedrijfsgebruiker verwijderen",
  "permission_my_company_layout_view": "Mijn bedrijfsindeling bekijken",
  "permission_my_company_layout_edit": "Mijn bedrijfsindeling bewerken",
  "permission_dashboard_view": "Dashboard bekijken",
  "permission_customer_support_view": "Klantondersteuning bekijken",
  "permission_admin_company_permission_view": "Bedrijfsrechten beheerder bekijken",
  "permission_admin_company_permission_edit": "Bedrijfsrechten administrateur bewerken",
  "permission_my_company_user_permissions_view": "Bekijk de gebruikersrechten van mijn bedrijf",
  "permission_my_company_user_permissions_edit": "Mijn bedrijfsgebruikersrechten bewerken",
  "permission_master_data_view": "Stamgegevens bekijken",
  "permission_master_data_permissions_roles_view": "Master data permissies rollen bekijken",
  "permission_master_data_permissions_roles_edit": "Master data permissies rollen bewerken",
  "permission_admin_automatic_invoicing_view": "Beheerder automatische facturatie bekijken",
  "permission_no_company_privileges": "Er zijn geen bedrijfsprivileges ingesteld",
  "user_allowed_events": "Selecteer specifieke evenementen die de gebruiker kan zien",
  "permission_role_templates": "Rolsjablonen",
  "permission_events_selected": "Geselecteerde evenementen",
  "permission_all_events": "Alle evenementen",
  "search": "Zoeken",
  "permission_master_data_permission_roles_create": "Master data permissie rollen creëren",
  "permission_master_data_permissions_roles_delete": "Stamgegevens machtigingen rollen verwijderen",
  "permission_admin_company_add_company": "Admin bedrijf kan bedrijf toevoegen",
  "permission_admin_company_automatic_invoicing_edit": "Admin automatische facturatie bewerken",
  "permission_admin_company_users_view": "Admin bedrijfsgebruikers bekijken",
  "permission_admin_company_users_edit": "Admin bedrijfsgebruikers bewerken",
  "permission_admin_company_users_delete": "Admin bedrijfsgebruikers verwijderen",
  "permission_order_detail_payment_history_view": "Order detail betalingsgeschiedenis bekijken",
  "permission_order_detail_notes_view": "Detailweergave van de bestelling",
  "permission_order_detail_notes_create": "Bestel detail notities maken",
  "permission_order_detail_log_view": "Logboek van de bestelling",
  "permission_my_company_users_view": "Mijn bedrijf gebruikers bekijken",
  "permission_event_visitor_list_view": "Bezoekerslijst evenement",
  "event_created": "Evenement is aangemaakt",
  "scan_operation_created": "Scanoperatie is aangemaakt",
  "ticket_template_created": "Ticket sjabloon is aangemaakt",
  "permission_my_company_settings_edit": "Mijn bedrijfsinstellingen bewerken",
  "permission_my_company_settings_view": "Mijn bedrijfsinstellingen bekijken",
  "permission_scan_terminal_view": "Weergave scan terminal",
  "permission_admin_company_details_page_view": "Admin bedrijfsgegevens pagina bekijken",
  "event_duplicated": "Evenement is gedupliceerd",
  "admin_company_payment_costs_create": "Betalingsmethode toevoegen",
  "admin_company_add_payment_method": "Betalingsmethode toevoegen",
  "admin_company_payment_method": "Betalingsmethode",
  "admin_company_payment_method_fee_percentage": "Fee in percentage",
  "admin_company_payment_method_fee_fixed": "Vaste fee",
  "admin_company_payment_method_start_at": "Geldig vanaf",
  "error_fee_fixed_amount": "Fixed fee is verplicht",
  "error_fee_percentage": "Fee percentage is verplicht",
  "admin_company_payment_method_added": "Betalingsmethode toegevoegd",
  "my_company_layout_remove_image": "Afbeelding verwijderen",
  "my_company_invoice_language": "In welke taal moet de factuur opgesteld worden?",
  "permission_discountcode_delete": "Kortingscode verwijderen",
  "discountcode_deleted": "Kortingscode verwijderd",
  "discountcode_is_used": "Kortingscode is al gebruikt en kan daarom niet verwijdert worden",
  "order_details_change_order_event": "Overzetten naar ander evenement",
  "order_details_event_changed_message": "Bestelling is succesvol overgezet",
  "permission_order_detail_change_event": "Bestelling overzetten naar andere evenementen",
  "pos_payment_method_not_exists": "De betaalmethode van het verkooppunt bestaat niet",
  "order_details_change_event_modal_products_title": "Kies de nieuwe producten",
  "order_details_change_event_modal_event": "Kies het evenement waar de bestelling naar overgeplaatst moet worden",
  "order_details_change_event_modal_pos": "Kies het verkooppunt waarnaar u de bestelling wilt verplaatsen",
  "permission_admin_company_fee_view": "Admin fees bekijken",
  "permission_admin_company_fee_edit": "Admin fees bewerken",
  "permission_admin_company_fee_add": "Admin fees toevoegen",
  "admin_company_add_company_fee": "Fees toevoegen",
  "admin_company_fee_type": "Type vergoeding",
  "admin_company_fee": "Vergoeding",
  "admin_company_fee_start_at": "Begin bij",
  "admin_company_company_fee_updated": "Fees bijgewerkt",
  "admin_company_company_fee_added": "Fees toegevoegd",
  "admin_company_company_fee_ticket_fee": "Ticketprijs",
  "admin_company_company_fee_box_office_ticket_fee": "Kassa ticket vergoeding",
  "admin_company_company_fee_refund_fee": "Restitutie vergoeding",
  "admin_company_company_fee_free_tickets_free_percentage": "Gratis tickets gratis percentage",
  "admin_company_company_fee_free_ticketfee": "Gratis ticket vergoeding",
  "update": "Update",
  "administration_overview_invoice": "Facturen overzicht",
  "backend_title_invoices_overview": "Facturen overzicht",
  "permission_admin_administration_view": "Administratie bekijken",
  "permission_invoice_details_view": "Factuur details bekijken",
  "permission_invoice_overview_search": "Facturen overzicht zoeken",
  "permission_invoice_overview_view": "Facturen overzicht bekijken",
  "permission_order_detail_generate_ticket": "Besteldetail genereer nieuw ticket",
  "permission_invoice_details_create_credit_invoice": "Factuur details creditfactuur aanmaken",
  "invoice_details_create_credit_invoice": "Creditfactuur aanmaken",
  "permission_mgmt_app_login": "Mag inloggen",
  "permission_mgmt_app_event_submenu_checkin_view": "Inchecken overzicht",
  "permission_mgmt_app_event_scan_total_tickets_scanned_view": "Zie totaal aantal gescande tickets op het scan scherm",
  "permission_mgmt_app_event_checkin_swipe_checkout": "Inchecken swipe uitchecken",
  "permission_mgmt_app_event_dashboard_tickets_sold_view": "Dashboard verkochte tickets overzicht",
  "permission_mgmt_app_ticket_detail_view": "Kan ticket details bekijken",
  "permission_mgmt_app_event_scan_ticket_details_view": "Toon ticket details na een scan",
  "permission_mgmt_app_prices_view": "Prijzen tonen",
  "permission_mgmt_app_event_overview_active_events": "Actieve evenementen bekijken",
  "permission_mgmt_app_event_overview_past_events": "Gearchiveerde evenementen bekijken",
  "permission_mgmt_app_menu_search_in_all_orders_view": "Zoeken in alle bestellingen",
  "permission_mgmt_app_menu_device_settings_view": "Menu apparaat instellingen",
  "permission_mgmt_app_menu_event_overview_view": "Menu evenementen overzicht",
  "permission_mgmt_app_event_dashboard_tickets_scanned_view": "Dashboard gescande tickets overzicht",
  "permission_mgmt_app_event_submenu_dashboard_view": "Dashboard overzicht",
  "permission_mgmt_app_event_submenu_orders_view": "Bestellingen overzicht",
  "permission_mgmt_app_event_submenu_home_view": "Evenementen overzicht",
  "permission_mgmt_app_event_checkin_swipe_checkin": "Inchecken swipe inchecken",
  "permission_mgmt_app_event_checkin_scan_btn_view": "Inchechen toon scan button",
  "permission_mgmt_app_ticket_detail_btn_checkout": "Ticket details uitchecken",
  "permission_mgmt_app_ticket_detail_btn_checkin": "Ticket details inchecken",
  "permission_mgmt_app_event_checkin_product_settings_view": "Inchecken specifieke producten instellingen bekijken",
  "permission_mgmt_app_event_checkin_product_settings_update": "Kan te scannen producten instellen",
  "permission_mgmt_app_ticket_sales_view": "Mag ticket verkopen inzien",
  "administration_invoice_number": "Factuurnummer",
  "permission_administration_overrule_fees_per_event_view": "Administratie overrule fees per evenement bekijken",
  "permission_administration_overrule_fees_per_event_edit": "Administratie overrule fees per evenement wijzigen",
  "administration_event_fees": "Overrule fees per evenement",
  "event_fees_retroactive": "Met terugwerkende kracht",
  "edit": "Bewerk",
  "company": "Bedrijf",
  "permission_mgmt_app_user_device_settings_view": "Instellingen gebruikersapparaat bekijken",
  "permission_mgmt_app_user_device_settings_update": "Instellingen gebruikersapparaat bijwerken",
  "pos_terms_conditions_url": "Link naar Algemene Voorwaarden",
  "cart_terms_conditions2": "Door te klikken op de knop 'Verder' bevestigt u dat u de <a href='{url}' target='_blank'>algemene voorwaarden</a> & <a href='https://fairtix.io/nl/privacy-policy' target='_blank'>Privacybeleid</a> van Fairtix en de <a href='{url2}' target='_blank'>algemene voorwaarden</a> van {name} gelezen hebt en ermee akkoord gaat.",
  "pos_invalid_url": "Ongeldige URL",
  "company_tickets_sold_out_notification": "Stuur bijna uitverkocht melding",
  "report_days_before_event": "{days} dagen voor event",
  "report_event_day": "Begindatum evenement",
  "report_days_from_event": "{days} dagen na event",
  "report_free_tickets": "Waarvan gratis tickets",
  "company_layout_logo_url": "Logo url",
  "pos_stock_pos": "Verkooppunt",
  "pos_stock_product": "Product",
  "pos_stock_product_stock": "Totaal beschikbare aantal",
  "pos_stock_in_redis": "In redis",
  "pos_stock_pos_stock": "Verkooppunt voorraad",
  "pos_stock_sold": "Verkocht",
  "email_confirmation": "Bevestig e-mail",
  "customer_form_email_confirmation_not_match": "E-mail komt niet overeen",
  "report_in_worth_of": "Ter waarde van",
  "order_already_paid": "Bestelling reeds betaald!",
  "customer_form_click_on_claim_button": "Klik op de knop Claim ticket om het ticket naar uw e-mailadres te sturen",
  "pos_no_language": "Geen taal geselecteerd",
  "customer_information_specific_tickets": "Stel deze vraag alleen als de bestelling specifieke tickets bevat",
  "scan_terminal_choose_event_title": "Kies een evenement waarvoor u de scan terminal wilt starten.",
  "permission_scan_terminal_login": "Inloggen Scan terminal",
  "permission_scan_terminal_ticket_overview": "Overzicht tickets Scan terminal",
  "no_events_to_show": "Geen evenementen te tonen",
  "reports_scans_by_type": "Scans by type",
  "reports_tickets_scans": "Tickets scans",
  "reports_tickets_scans_hourly": "Hourly",
  "reports_tickets_scans_daily": "Daily",
  "reports_tickets_scans_weekly": "Weekly",
  "reports_tickets_scans_monthly": "Monthly",
  "reports_period": "Periode",
  "reports_time_from": "Tijd van",
  "reports_time_to": "Tijd tot",
  "reports_tickets_scanned": "Tickets gescand",
  "customer_information_field": "Veld",
  "customer_information_order_ask": "Bestelling vraag",
  "customer_information_order_mandatory": "Verplicht vraag",
  "customer_information_ticket_ask": "Vraag per ticket",
  "customer_information_ticket_mandatory": "Verplicht vraag",
  "customer_information_specific_question": "Vraag",
  "customer_information_specific_question_type": "Type vraag",
  "report_sold_out": "Uitverkocht",
  "back": "Terug",
  "my_company_allowed_events_days": "De gebruiker krijgt toegang tot alle evenementen die plaatsvinden op de dagen die u hieronder selecteert",
  "day_mon": "Mon",
  "day_tue": "Tue",
  "day_wed": "Wed",
  "day_thu": "Thu",
  "day_fri": "Fri",
  "day_sat": "Sat",
  "day_sun": "Sun",
  "company_paynl_account_type": "Pay.nl account type",
  "company_payout_iban": "Uitbetaling IBAN nummer",
  "company_name_is_required": "Naam is vereist",
  "company_domain_is_required": "Subdomein is vereist",
  "company_contact_is_required": "Contactpersoon is vereist",
  "pos_url_exists": "Sommige of alle POS-urls worden gebruikt",
  "permission_event_show_minimum_age_checkbox": "Evenement tonen minimum leeftijd checkbox",
  "event_age_confirmation_form": "Laat de klant een checkbox aanvinken om te bevestigen dat hij minstens {age} oud is",
  "pos_age_confirmation": "Ik bevestig dat ik en de andere personen voor wie ik tickets bestel ten minste {minimum_age} of ouder zijn.",
  "ticket_template_duplicate" : "Duplicaat sjabloon",
  "ticket_template_delete_entry" : "Weet je zeker dat je dit ticket template wilt verwijderen?",
  "name_is_required" : "Naam is verplicht",
  "permission_ticket_template_duplicate": "Ticket template dupliceren",
  "default_account_setup": "Standaard accountconfiguratie",
  "backend_title_default_company_layout": "Standaard bedrijfslay-out",
  "backend_title_default_company_fees": "Standaard fees",
  "backend_title_default_company_permissions": "Standaard machtigingen",
  "backend_title_default_ticket_template": "Default ticket template",
  "default_company_layout": "Standaard bedrijfslay-out",
  "default_company_fees": "Standaard fees",
  "default_company_permissions": "Standaard machtigingen",
  "default_company_ticket_template": "Default ticket template",
  "permission_master_data_default_values_permissions_edit": "Standaardmachtigingen bewerken",
  "permission_master_data_default_values_permissions_view": "Standaard machtigingenweergave",
  "permission_master_data_default_values_view": "Weergave standaardwaarden",
  "permission_master_data_default_values_layout_edit": "Standaard bedrijfslay-out bewerken",
  "permission_master_data_default_values_layout_view": "Standaard lay-outweergave van het bedrijf",
  "permission_master_data_default_values_fees_edit": "Standaard bedrijfskosten bewerken",
  "permission_master_data_default_values_fees_view": "Standaard weergave bedrijfskosten",
  "permission_master_data_default_values_ticket_template_view": "Standaard weergave ticket template",
  "permission_master_data_default_values_ticket_template_edit": "Standaard ticket template bewerken",
  "field_is_required": "Veld is verplicht",
  "password_mismatch": "Wachtwoord komt niet overeen",
  "user_already_exists": "Gebruiker bestaat al",
  "signup_create_account": "Maak account aan",
  "signup_enter_details": "Het aanmaken van het account is volledig gratis!",
  "signup_chamber_of_commerce": "KVK nummer",
  "signup_iban": "IBAN",
  "signup_iban_holder_name": "IBAN rekeninghouder naam",
  "signup_confirm_password": "Bevestig wachtwoord",
  "signup_terms": "Ik ga akkoord met de <a target='_blank' href='https://fairtix.io/nl/terms-conditions'>Algemene voorwaarden</a> en verklaar bevoegd te zijn om te ondertekenen in naam van de opgegeven organisatie",
  "signup_already_user": "Al een account?",
  "signup_loading_creating_account": "Account creëren...",
  "signup_loading_configuring_the_layout": "De lay-out configureren...",
  "signup_loading_almost_done": "Bijna klaar...",
  "signup_loading_go_to_dashboard": "Ga naar Dashboard als ingelogde gebruiker",
  "default_template_text": "Standaard template",
  "signup_step_2_title": "Maak het account compleet",
  "signup_step_2_enter_details": "Vul de laatste gegevens in",
  "edit_ticket_template_err_no_jpg": "Gekozen afbeelding moet een JPG zijn",
  "edit_ticket_template_err_no_textbox": "Er dient minimaal één textbox te zijn",
  "error_background": "Afbeelding is verplicht",
  "event_description_location": "Waar wil je de omschrijving tonen",
  "manage_event_desc_location_top": "Bovenaan de pagina",
  "manage_event_desc_location_bot": "Onderaan de pagina",
  "event_show_image_in_pos": "Toon afbeelding op verkooppagina",
  "product_scan_color": "Overrule scan kleur",
  "product_scan_color_explenation": "Als hier een kleur ingesteld is, zal deze getoond worden zodra dit ticket succesvol gescand wordt",
  "product_remove_scan_color": "Verwijder scan kleur",
  "pos_no_products_and_pm_are_configured": "Er zijn geen producten & betaalmethoden geconfigureerd",
  "pos_no_products_are_configured": "Er zijn geen producten geconfigureerd",
  "pos_no_pm_are_configured": "Er zijn geen betaalmethoden geconfigureerd",
  "event_marketing_updated": "Evenement marketing bijgewerkt",
  "permission_event_marketing_view": "Evenement marketing bekijken",
  "permission_event_marketing_edit": "Evenement marketing wijzigen",
  "event_marketing_gtm_id": "Google Tag Manager ID",
  "event_marketing_gtm_id_tooltip": "Zodra het GTM ID is ingevuld zal GTM geactiveerd worden op de verkooppagina. Maak dit veld leeg om het weer uit te schakelen.",
  "edit_ticket_template_err_textbox_field": "Alle tekstvakjes zijn verplicht",
  "discountcode_times_used": "Gebruikte tijden",
  "nav_campaigns": "Campagnes",
  "campaign_create": "Campagne aanmaken",
  "campaign_modal_create": "Een nieuwe campagne aanmaken",
  "campaign_name": "Naam campagne",
  "campaign": "Campagne",
  "slug": "Slug",
  "event_day_selector": "Evenement/Dag selector",
  "campaign_discount_rules": "Kortingsregels",
  "campaign_discount_type": "Korting type",
  "campaign_discount_value": "Waarde korting",
  "campaign_new_discount_rule": "Nieuwe kortingsregel",
  "campaign_reference": "Referentie",
  "campaign_when_does_this_discount_apply": "Wanneer is deze korting van toepassing",
  "campaign_timeframe_from": "Tijdsbestek van",
  "campaign_timeframe_to": "Tijdsbestek tot",
  "reference_is_required": "Referentie is vereist",
  "campaign_edit_rule": "Regel bewerken",
  "campaign_rule_set_product_price": "Prijs product",
  "campaign_rule_set_product_name": "Naam product",
  "campaign_updated": "Campagne succesvol bijgewerkt",
  "slug_is_required": "Slug is vereist",
  "campaign_company_url": "Bedrijfscampagne URL",
  "campaign_deleted": "Campagne succesvol verwijderd",
  "cannot_delete_campaign": "Kan campagne niet verwijderen, er zijn bestellingen gelinkt",
  "campaign_times_used": "Keren gebruikt",
  "campaign_total_revenue": "Totale opbrengst",
  "slug_already_used": "Slug reeds in gebruik",
  "copied_to_clipboard": "Gekopieerd naar klembord!",
  "nav_batches": "QR Code Batches",
  "batch_name": "Naam van de batch",
  "ticket_name": "Naam ticket",
  "ticket_price": "Ticket prijs",
  "ticket_vat": "BTW tarief",
  "tickets_count": "Hoeveel QR codes wil je aanmaken",
  "batch_detail_starts_at": "QR codes geldig vanaf",
  "batch_detail_ends_at": "QR codes geldig tot",
  "batch_events_or_days": "Kies de evenementen of dagen waar de batch op geldig is",
  "edit_batch_title": "Batch bewerken",
  "create_batch": "Batch aanmaken",
  "batch_created": "Aangemaakt",
  "batch_updated": "Batch bijgewerkt",
  "batch_modal_create": "Nieuwe batch aanmaken",
  "ticket_name_is_required": "Ticketnaam is verplicht",
  "ticket_price_is_required": "Ticketprijs is verplicht",
  "ticket_vat_is_required": "Ticket Vat Vereist",
  "tickets_count_err": "Het aantal QR codes moet hoger dan 0 en minder dan 5000 zijn",
  "batch_generate": "Genereer QR batch",
  "batch_download": "Download QR batch",
  "batch_generated": "De QR codes worden aangemaakt, dit kan even duren",
  "batch_already_generated": "Batch is al gegenereerd",
  "order_overview_remove_discountcode_filter": "Verwijder kortingscode filter",
  "discountcode_overview_show_orders": "Toon bestellingen",
  "discountcode_tickets_times_used": "Aantal tickets",
  "report_age_avg": "Gemiddelde leeftijd",
  "pos_countdown": "Toon aftel klok",
  "pos_countdown_datetime": "Tot wanneer moet de klok aftellen",
  "dashboard_modal_active_carts": "Actieve winkelwagens",
  "layout_countdown": "Countdown klok",
  "layout_countdown_card_top": "Bovenkant kaart klok",
  "layout_countdown_card_bottom": "Onderkant kaart klok",
  "layout_countdown_card_text": "Tekstkleur cijfers",
  "permission_campaigns_view": "Campagnes bekijken",
  "permission_campaigns_create": "Campagnes toevoegen",
  "permission_campaigns_edit": "Campagnes bewerken",
  "permission_campaigns_delete": "Campagnes verwijderen",
  "discountcode_allowed_events": "Toegestane evenementen",
  "discountcode_allowed_products": "Toegestane producten",
  "order_discountcode": "Kortingscode",
  "order_overview_batch_ticket": "Batch ticket",
  "download": "Download",
  "qr_code": "QR code",
  "pos_qr_description": "Deze QR-code is gekoppeld aan het verkooppunt. Deze kan worden gebruikt op uw flyer of voor andere marketingdoeleinden",
  "campaign_highlight_discount": "Markeer de producten met kortingen",
  "campaign_highlight_discount_border_color": "Rand kleur",
  "campaign_highlight_discount_background_color": "Achtergrond kleur",
  "campaign_hide_products": "Ik wil een aantal specifieke producten verbergen op de verkooppagina",
  "campaign_when_hide_products": "Verberg de producten wanneer:",
  "different": "Anders",
  "event_vat_is_required": "BTW is vereist",
  "password_validation_8_chars": "Wachtwoord moet minstens 8 tekens lang zijn",
  "password_validation_lowercase": "Wachtwoord moet minstens één kleine letter bevatten",
  "password_validation_capital": "Wachtwoord moet minstens één hoofdletter bevatten",
  "password_validation_number": "Wachtwoord moet minstens één cijfer bevatten",
  "signup_confirm_account": "Bevestig uw gegevens",
  "signup_password_strength": "Het wachtwoord moet 8 tekens bevatten en ten minste 1 cijfer, 1 letter, 1 hoofdletter en 1 speciaal teken.",
  "discountcode_apply_type": "Hoe wilt u de korting berekenen:",
  "discountcode_apply_type_order": "Per bestelling",
  "discountcode_apply_type_ticket": "Per ticket",
  "campaign_qr_description": "Deze QR-code is gekoppeld aan de campagne. Deze kan worden gebruikt op uw flyer of op een andere manier worden verspreid",
  "password_validation_special_char": "Wachtwoord moet minstens één speciaal teken bevatten",
  "export_customer_dob": "Geboortedatum klant",
  "export_order_timeslot": "Tijdslot",
  "product_show_when_product_chosen": "Toon dit product alleen als een ander product is gekozen",
  "event_products_selected": "product(en) geselecteerd",
  "event_products_no_selected": "geen producten geselecteerd",
  "product_show_hide_input_fields": "Invoervelden tonen/verbergen",
  "product_min_max_buy_per_product": "Min & max aankoop per order",
  "product_more_items": "Meer artikelen",
  "product_image_validate_size": "De afbeelding moet kleiner zijn dan 4MB",
  "product_image_validate_resolution": "De afbeeldingsresolutie moet kleiner zijn dan 120x120 px",
  "product_sell_product_sets": "Product verkopen in sets van",
  "master_data_auto_invoice_settings": "Instellingen automatisch factureren",
  "nav_auto_invoice_settings": "Automatisch factureren instellingen",
  "auto_invoice_settings_general_stop": "Is automatisch factureren actief?",
  "changes_saved": "Wijzigingen opgeslagen!",
  "error_max_buy": "Max per bestelling is verplicht",
  "error_min_buy": "Min per bestelling is verplicht",
  "product_price_inclusive_vat": "Prijs (incl. BTW)",
  "product_image_tooltip": "De afbeelding moet minder dan 4 MB groot zijn, een maximale resolutie hebben van 120x120 PX en in PNG- of JPEG-formaat zijn",
  "product_send_additional_ticket": "Stuur een extra ticket",
  "product_send_additional_ticket_ordered": "Stuur een extra ticket wanneer dit product wordt besteld",
  "product_addition_already_set": "Dit ticket is al ingesteld als extra ticket voor {product}",
  "product_additional_ticket_description": "Wanneer dit product wordt besteld, worden de producten die u hieronder selecteert automatisch toegevoegd aan de winkelwagen bij de bestelling",
  "event_product_send_email": "Stuur een e-mail wanneer dit product is besteld naar",
  "email_is_invalid": "Voeg een geldig e-mailadres toe",
  "permission_product_ordered_email_confirmation": "Bevestiging van bestelde producten per e-mail",
  "guest_list_order_ticket_send_successfully": "Tickets zijn succesvol verzonden",
  "guest_list_order_ticket_generated": "De tickets worden gegenereerd en verzonden, wacht tot dit proces is voltooid...",
  "pos_free_order_btn": "Doorgaan met het plaatsen van de bestelling",
  "company_invoice_overview": "Facturen",
  "company_invoice_overview_invoice": "Factuur",
  "company_invoice_overview_payout_summary": "Uitbetaling onderbouwing",
  "invoice_number": "Factuurnummer",
  "all_events": "Alle evenementen",
  "company_invoice_downloads": "Downloads",
  "company_paynl_merchant_id": "Pay.nl M-code",
  "company_invoice_overview_total_payout": "Totaal uitbetaling",
  "company_invoice_overview_clearing_ref": "Clearing referentie",
  "company_invoice_overview_time_period": "Tijdsperiode",
  "permission_company_invoice_view": "Facturen overzicht bekijken",
  "permission_company_invoice_can_download": "Mag facturen downloaden",
  "point_of_sale_modal_delete": "Verkooppunt verwijderen",
  "point_of_sale_delete_confirmation": "Weet u zeker dat u dit verkooppunt wilt verwijderen?",
  "point_of_sale_has_orders": "Verkooppunt bevat bestellingen, u kunt het niet verwijderen",
  "point_of_sale_has_been_deleted": "Verkooppunt is verwijderd",
  "permission_event_point_of_sale_delete": "Verkooppunt verwijderen",
  "campaign_overview_btn_link_generator": "Campagne link genereren",
  "campaign_link_modal_title": "Campagne link genereren",
  "campaign_campagne": "Campagne",
  "campaign_link_modal_link_type": "Waar wil je naartoe linken",
  "campaign_link_modal_event_overview": "Evenementen overzicht",
  "campaign_link_modal_specific_pos": "Specifiek evenement",
  "campaign_event": "Evenement",
  "campaign_pos": "Verkooppunt",
  "campaign_link_modal_link": "Link",
  "cart_incl_vat": "Incl. BTW",
  "fairtix_location_street": "Keizersveld 99",
  "fairtix_location_zip": "5803AP",
  "fairtix_location_city": "Venray",
  "fairtix_location_country": "Nederland",
  "fairtix_location_coc": "77888286",
  "fairtix_location_vat": "NL861186163B01",
  "shop_vat": "BTW",
  "extension_mailchimp": "Mailchimp",
  "extension_mailchimp_api_key": "API sleutel",
  "extension_mailchimp_audience_id": "Audience sleutel",
  "saved_successfully": "Succesvol opgeslagen",
  "extension_mailchimp_description": "Configureer je Mailchimp synchronisatie. Het e-mailadres, de voornaam en achternaam (indien beschikbaar) worden elke 60 minuten in batches naar Mailchimp gepushed. Als je de synchronisatie wilt stoppen, verwijder je gewoon de API-sleutel.",
  "monday": "Maandag",
  "tuesday": "Dinsdag",
  "wednesday": "Woensdag",
  "thursday": "Donderdag",
  "friday": "Vrijdag",
  "saturday": "Zaterdag",
  "sunday": "Zondag",
  "january": "Januari",
  "february": "Februari",
  "march": "Maart",
  "april": "April",
  "may": "Mei",
  "june": "Juni",
  "july": "Juli",
  "august": "Augustus",
  "september": "September",
  "october": "Oktober",
  "november": "November",
  "december": "December",
  "company_show_calendar": "Toon kalender op evenementen overzichtspagina",
  "company_calendar_sold_ratio": "Toon bezetting indicatie op kalender",
  "permission_extensions_overview_view": "Extensions overzicht bekijken",
  "permission_extension_mailchimp": "Mailchimp",
  "permission_batch_overview_view": "Batch overzicht bekijken",
  "permission_batch_edit": "Batch bewerken",
  "permission_batch_create": "Batch aanmaken",
  "permission_master_data_auto_invoice_settings_view": "Auto invoice instellingen bekijken",
  "permission_master_data_auto_invoice_settings_edit": "Auto invoice instellingen bewerken",
  "cookie_banner_title": "Cookies",
  "cookie_banner_personalize": "Personaliseer je voorkeuren",
  "cookie_banner_preference_local": "Lokaal opgeslagen informatie",
  "cookie_banner_preference_analytics": "Analytics",
  "cookie_banner_preference_marketing": "Marketing",
  "btn_accept_all": "Accepteer alles",
  "btn_accept_selected": "Accepteer geselecteerde",
  "cookie_banner_change_preference": "Cookievoorkeuren wijzigen",
  "cookie_banner_text": "Onze website maakt gebruik van cookies om jou de optimale gebruikerservaring te bieden. Hiermee kunnen we bijv. onthouden wat je aan je winkelwagen hebt toegevoegd. Daarnaast implementeren we diverse andere handige methoden om je ervaring te verbeteren.",
  "order_overview_payment_link": "Betalingslink",
  "guest_list_payment_link": "Betalingslink email",
  "guest_list_payment_link_send": "Betaallink verstuurd",
  "venues_overview": "Overzicht locaties",
  "venue_verified": "Geverifieerd",
  "venue_name": "Naam locatie",
  "new_venue": "Nieuwe locatie",
  "venue_new_modal_title": "Een nieuwe locatie maken",
  "venue_create_hint": "Zodra je je locatie hebt aangemaakt, kun je meer gedetailleerde informatie instellen!",
  "venue_modal_edit": "Locatie bewerken",
  "venue_address": "Adres locatie",
  "venue_zip": "Postcode locatie",
  "venue_active": "Actief",
  "venue_city": "Locatie stad",
  "venue_country": "Locatie land",
  "venue_saved": "Locatie opgeslagen!",
  "venue_deleted": "Locatie verwijderd!",
  "permission_master_data_venues_overview": "Overzicht locaties",
  "permission_venue_create": "Locatie aanmaken",
  "permission_venue_delete": "Locatie verwijderen",
  "permission_venue_edit": "Locatie bewerken",
  "permission_add_location_event_details": "Locatie toevoegen in de evenement details",
  "event_location": "Locatie",
  "venue_is_already_used": "Locatie wordt al gebruikt",
  "error_venue.name": "De naam van de locatie is vereist",
  "error_venue.address": "Adres van de locatie is vereist",
  "error_address": "Adres van de locatie is vereist",
  "error_venue.zip": "Postcode is vereist",
  "error_zip": "Postcode is vereist",
  "error_venue.city": "Plaats is vereist",
  "error_city": "Plaats is vereist",
  "error_venue.country_code": "Land van de locatie is vereist",
  "error_country_code": "Land van de locatie is vereist",
  "edit_ticket_template_reached_limit": "De afbeelding moet kleiner zijn dan 300KB",
  "company_links_overview": "Bedrijf Links",
  "company_master_name": "Bedrijf Master",
  "company_sub_name": "Bedrijf Sub",
  "location_id": "Locatie",
  "location_name": "Locatie",
  "company_link_new_modal_title": "Een nieuwe bedrijfskoppeling maken",
  "company_link_modal_edit": "Bedrijfslink bewerken",
  "company_link_saved": "Bedrijfslink opgeslagen!",
  "company_link_deleted": "Bedrijfslink verwijderd",
  "company_link_duplicate_entry": "Duplicatie van bedrijfskoppelingen",
  "company_link_master_sub_not_equal": "Bedrijfsleider mag geen bedrijfsondergeschikte zijn",
  "error_company_master_id": "Company master is vereist",
  "error_company_sub_id": "Bedrijfsonderdeel is vereist",
  "permission_master_data_company_links_overview": "Overzicht bedrijfskoppelingen",
  "permission_master_data_company_links_create": "Bedrijfslink maken",
  "permission_master_data_company_links_edit": "Bedrijfslink bewerken",
  "permission_master_data_company_links_delete": "Bedrijfslink verwijderen",
  "company_link_unallowed_parent_child_entry": "Sub bedrijf kan geen ondergeschikt account zijn voor dit bedrijf, omdat er al een koppeling bestaat waar het bedrijf een hoofdaccount is",
  "end_date_must_be_greater": "Einddatum moet groter zijn dan begindatum",
  "product_limit_amount_to_maximum_tickets": "Beperk het aantal tot het maximum van andere tickets",
  "birth_date_must_be_past": "Geboortedatum moet in het verleden liggen",
  "product_scan_till_date_time": "Specifieke scan tijd",
  "url_cannot_spaces": "URL kan geen spaties bevatten",
  "event_banner_tooltip": "Deze afbeelding wordt getoond in het pos-overzicht op de desktopversie",
  "event_banner_image": "Banner (1180x174 pixels) (<=1MB)",
  "manage_event_remove_banner": "Banner verwijderen",
  "manage_event_banner_error_res": "De resolutie van de bannerafbeelding moet (1180x174 pixels) zijn",
  "manage_event_banner_error_size": "Bannerafbeelding moet kleiner zijn dan 1MB",
  "order_number_of_products": "Aantal producten",
  "user_app_login_duration": "Maximale inlogtijd in de app (in uren)",
  "edit_user_modal_app_login_duration_error": "De maximale inlogtijd in de app moet groter zijn dan 0",
  "download_tickets": "Download tickets",
  "order_status_ticket_merging": "Tickets worden samengevoegd",
  "invoice_overview_btn_generate_invoice": "Genereer factuur",
  "invoice_overview_btn_generate_payout_summary": "Genereer uitbetaling onderbouwing",
  "administration_invoice_payout_summary_generation": "Mag factuur en uitbetaling onderbouwing genereren",
  "invoice_overview_file_generated": "Bestand gegenereerd",
  "ticket_template_qr_code_4cm": "QR code moet 1,5cm (57pt) gepositioneerd zijn vanaf de paginaranden",
  "ticket_template_qr_size": "De QR code mag niet kleiner dan 100x100 zijn en niet groter dan 225x225",
  "export_product_ticket_value": "Unieke ticket code",
  "select": "Selecteer...",
  "permission_administration_invoice_payout_summary_generation": "Mag factuur en uitbetaling onderbouwing genereren",
  "ticket_lost_title": "Tickets verloren?",
  "ticket_lost_description": "Vul de onderstaande velden in om uw tickets terug te krijgen",
  "ticket_lost_no_orders":  "We hebben uw bestelling(en) niet gevonden, neem contact op met support-AtSign-fairtix.io voor meer informatie",
  "ticket_lost_search_tickets": "Zoek tickets",
  "ticket_lost_your_orders_description": "Alle tickets zijn naar jouw e-mailadres gestuurd. Controleer ook de spam folder.",
  "wrong_email": "Onjuist e-mail adres",
  "wrong_date":  "Ongeldige datum",
  "company_order_thank_you_show_events": "Toon evenementen op de bedankpagina",
  "order_thank_you_btn_event_details": "BESTEL NU",
  "order_thank_you_upcoming_events": "Mis ook deze evenementen niet!",
  "dashboard_events_ticket_sold": "verkocht",
  "dashboard_events_ticket_guest_list": "Aantal gastenlijst",
  "dashboard_events_yesterday": "Gisteren",
  "date_and_time": "Datum en tijd",
  "start_date": "Begindatum",
  "end_date": "Einddatum",
  "event_modal_create": "Evenement aanmaken",
  "lang_fr": "Frans",
  "lang_pt": "Portugees",
  "pos_will_automatically_redirect": "We sturen je automatisch binnen {seconds} seconden door naar het actieve evenementenoverzicht",
  "pos_redirect_now": "Nu doorsturen",
  "guest_list_event_name": "Voor welk evenement wil je gastenlijst tickets sturen?",
  "guest_list_customer": "Naar wie wil je de tickets toe sturen?",
  "guest_list_select_products": "Hoeveel wil je van welk ticket sturen?",
  "guest_list_send_to_email": "Stuur tickets naar {email}",
  "guest_list_send_payment_request":"Verstuur betaalverzoek naar {email}",
  "guest_list_send_invitation_to_sign": "Stuur uitnodiging om tickets op naam te zetten",
  "guest_list_select_payment": "Wat wil je met de betaling doen?",
  "guest_list_select_payment_free": "Geen betaling noding",
  "guest_list_select_payment_paid": "Er is contant betaald",
  "guest_list_send": "Versturen",
  "guest_list_choose_tickets_to_send": "Kies tickets om te sturen",
  "guest_list_ticket_type": "Ticket type",
  "guest_list_price": "Prijs",
  "guest_list_number": "Aantal",
  "pos_only_available_x": "Max: {amount} beschikbaar",
  "ticket_template_deleted": "Ticket sjabloon succesvol verwijderd",
  "ticket_template_cannot_deleted":"Ticket sjabloon kan niet worden verwijderd",
  "permission_ticket_template_delete": "Ticket sjabloon verwijderen",
  "order_overview_api_order": "API",
  "guest_list_remember_event": "Onthoud evenement",
  "order_export_export": "Export",
  "order_export_generate_export": "Export genereren",
  "order_export_type": "Wat voor export wil je maken?",
  "order_export_visitor_list": "Bezoekerslijst (voor specifieke tickets)",
  "order_export_general": "Algehele export",
  "order_export_which_event": "Voor welk evenment?",
  "order_export_event": "Kies het eventment",
  "order_export_which_tickets": "Voor welke tickets?",
  "order_export_select_tickets": "Kies de tickets",
  "order_export_selected_tickets": "{count} ticket(s) geselecteerd",
  "order_export_which_email": "Naar welk email adres wil je de export sturen?",
  "order_export_period": "Welke tijdsperiode?",
  "order_export_which_fields": "Welke velden wil je in de export?",
  "order_export_success": "Succesvol aangevraagd",
  "order_export_all_tickets": "Alle tickets",
  "event_product_allow_for_multiple_events": "Meerdere evenementen toestaan",
  "select_events": "Evenementen selecteren",
  "event_duplicate_product_allowed_events_note": "LET OP: je moet handmatig nieuwe evenementen aan dit product koppelen na het dupliceren.",
  "order_export_success_message": "Je export is succesvol aangevraagd en zal naar {email} worden toegestuurd. Dit kan enkele minuten duren, afhankelijk van de grootte van het bestand.",
  "order_export_select_specific_event": "Selecteer het evenement",
  "event_product_available_amount": "Aantal beschikbaar",
  "event_product_create_hint": "Nadat je het ticket hebt aangemaakt, kun je indien nodig meer opties instellen.",
  "event_product_type_entrance": "Toegang",
  "event_product_type_tokens": "Tokens",
  "event_product_type_parking": "Parkeren",
  "event_product_type_cross-sell": "Cross-sell",
  "event_product_type_merchandise": "Merchandise",
  "event_product_type_donation": "Donatie",
  "event_product_type_other": "Andere",
  "event_product_create_success": "Product succesvol aangemaakt.",
  "pos_buy_your_tickets": "Koop nu je tickets!",
  "pos_timeslot_choose_the_time":"Kies het tijdstip van je bezoek",
  "pos_personal_details": "Persoonlijke gegevens",
  "pos_personal_details_complete_purchase":"Voltooi je aankoop",
  "pos_payment": "Betaling",
  "pos_payment_description":"Kies een betaalmethode",
  "pos_order_success_title": "Je bestelling: #{order_number} is succesvol geplaatst!",
  "event_product_persons":"Aantal personen",
  "persons": "Personen",
  "pos_place_order_total":"Totaal (incl. BTW & €{total} boekingskosten)",
  "pos_place_order_got_a_code": "Heb je een code?",
  "read_more": "Meer lezen",
  "read_less": "Minder lezen",
  "layout_accent_color": "Accent kleur",
  "layout_description_color": "Kleur beschrijving",
  "layout_buttons_color": "Knop kleur",
  "layout_button_text_color": "Knop tekstkleur",
  "pos_important_information": "Belangrijke informatie",
  "shop_no_products_selected": "Selecteer producten om verder te gaan",
  "pos_buy_extra_products": "Koop extra producten",
  "event_description_open_status": "Omschrijving direct tonen",
  "event_manage_event_description_show_tooltip": "Als deze optie is ingeschakeld, wordt de omschrijving van het evenement direct getoond op de evenementenpagina. Indien deze niet is ingeschakeld dienen mensen dit handmatig uit te klappen.",
  "event_products_create_first_ticket": "Maak je eerste ticket aan!",
  "event_products_create_ticket_hint": "Elk geweldig evenement begint met één ticket - de jouwe! Klik op die knop en maak je ticket aan.",
  "event_products_create_ticket_btn": "Maak ticket aan",
  "event_products_create_pos": "Maak je verkooppunt aan!",
  "event_products_create_pos_hint": "Om tickets te kunnen verkopen, heb je een verkooppunt nodig! Klik op de knop en maak je verkooppunt aan.",
  "event_products_create_pos_btn": "Maak verkooppunt aan",
  "event_selected_products": "product(en)",
  "event_products_mass_update": "Massa-update product",
  "event_products_group_name": "Groepsnaam",
  "event_products_capacity": "Capaciteit",
  "event_product_mass_update_success": "Producten succesvol bijgewerkt",
  "pos_fill_in_discount_code": "Vul uw kortingscode in",
  "discount_code": "Kortingscode",
  "something_went_wrong": "Er ging iets mis",
  "pos_use_discount_code": "Gebruik kortingscode",
  "btn_apply": "Toepassen"
}